module.exports = __webpack_public_path__ + "img/dc_01.889b84ba.jpg";